import script from "./OutOfService.vue?vue&type=script&setup=true&lang=js"
export * from "./OutOfService.vue?vue&type=script&setup=true&lang=js"

import "./OutOfService.vue?vue&type=style&index=0&id=ef8fee3a&lang=css"

const __exports__ = script;

export default __exports__